import axios from "axios";
import * as ActionType from "./cashoutRequest.type";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";

export const getCashoutRequest = (status = "") => (dispatch) => {
  const url = status
    ? `cashoutRequest/admin/getAllRequests?status=${status}`
    : `cashoutRequest/admin/getAllRequests`;

  apiInstanceFetch
    .get(url)
    .then((res) => {
      dispatch({
        type: ActionType.GET_CASHOUT_REQUEST,
        payload: res.requests || [],
      });
    })
    .catch((error) => console.error(error));
};

export const updateCashoutRequest = (requestId, status, transactionRef = "") => (dispatch) => {
  const formData = new FormData();
  formData.append("status", status);
  if (transactionRef) {
    formData.append("transactionReference", transactionRef);
  }

  axios
    .patch(`cashoutRequest/admin/updateStatus?requestId=${requestId}`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_CASHOUT_REQUEST,
          payload: { data: res.data.request, id: requestId },
        });
        setToast("success", `Cashout request ${status} successfully`);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to update cashout request");
    });
};

export const processCashout = (requestId, transactionRef) => (dispatch) => {
  const formData = new FormData();
  formData.append("transactionReference", transactionRef);

  axios
    .post(`cashoutRequest/admin/processCashout?requestId=${requestId}`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_CASHOUT_REQUEST,
          payload: { data: res.data.request, id: requestId },
        });
        setToast("success", "Cashout processed successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to process cashout");
    });
};

export const getCashoutStats = () => (dispatch) => {
  apiInstanceFetch
    .get(`cashoutRequest/admin/getStats`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_CASHOUT_STATS,
        payload: res.stats || {},
      });
    })
    .catch((error) => console.error(error));
};
